import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

const API_URL = import.meta.env.VITE_API_URL ? `${import.meta.env.VITE_API_URL}/api` : '/api';

async function fetchFeatures(): Promise<Record<string, boolean>> {
  const res = await fetch(`${API_URL}/settings/features`, {
    credentials: 'include',
  });
  if (!res.ok) return {};
  const data = await res.json();
  return data.features ?? {};
}

export function useFeatureFlags() {
  const { data: features = {}, isLoading } = useQuery({
    queryKey: ['feature-flags'],
    queryFn: fetchFeatures,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  const isEnabled = useCallback(
    (key: string) => {
      // While loading, show features to prevent layout flash
      if (isLoading) return true;
      // Fail closed: unknown/missing flags default to disabled
      return features[key] ?? false;
    },
    [features, isLoading]
  );

  return { features, isLoading, isEnabled };
}
